import { smb_fetch, getSsoCgiUrl } from '@/api/operator/fetch';
import { ExecuteResult } from '@/model/common';
import globalStore from '@/stores';

export interface IGetKeyEventListResponse {
  /** 事件列表 */
  key_event_list: {
    /** 事件类型 1-推广产品异常，2-新品助推，3-财务异常，4-风控违规，5-行业推荐新品 */
    event_type: number,
    /** 数量 */
    count: number,
    /** 涉及营销账户列表 */
    account_id_list: number[]
    /** 关联的客户主体列表 */
    customer_list: {
      /** 客户id */
      ad_customer_id: number;
      /** 客户名称 */
      ad_customer_name: string;
    }[]
  }[];
  /** 数据更新时间 */
  partition_time: number;
}

/**
 * 获取账号汇总数据
 */
export const getAccountSummaryData = (data: any) => {
  const url = getSsoCgiUrl('poe_service/v1/account', 'summary_data');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    headers: {
      'x-platform-type': 2, // 1：工作台  2.服务商
      'x-account-id': globalStore.account.bm_id || globalStore.account.agency_uid,
    },
    data,
  }, false, false);
};

/**
 * 获取重点事件
 * @param {*} data 查询条件
 */
export const getKeyEventList = (data: Record<string, any>): Promise<ExecuteResult<IGetKeyEventListResponse>> => {
  const url = getSsoCgiUrl('poe_service/v1/key_events', 'list');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    headers: {
      'x-platform-type': 2, // 1：工作台  2.服务商
      'x-account-id': globalStore.account.bm_id || globalStore.account.agency_uid,
    },
    data,
  }, false, false);
};
